import React from "react";
import { Link } from "react-router-dom";
import { useState } from 'react'

export default function Faq() {
    const [isActive, setIsActive] = useState({
        status: false,
        key: 1,
    })

    const handleToggle = (key) => {
        if (isActive.key === key) {
            setIsActive({
                status: false,
            })
        } else {
            setIsActive({
                status: true,
                key,
            })
        }
    }
    return (
        <>
            <section className="faq-2-section p_relative">
        <div className="p_absolute l_0 b_0 r_0 t_0" style={{background: 'url(assets/images/shape/pattern-9.png) no-repeat left bottom'}}></div>
        <div className="auto-container p_relative">
            <div className="faq-2-shape-1"><img src="assets/images/shape/pattern-1.png" alt="" /></div>
            <div className="faq-2-shape-2"><img src="assets/images/shape/pattern-1.png" alt="" /></div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="section_heading mb_20">
                        <span className="section_heading_title_small">Frequently Asked Question</span>
                        <h2 className="section_heading_title_big">Freequently Asked Questions</h2>
                    </div>
                  <p className="mb_30">
                        Have questions? We’ve got answers. <br />
                        Explore our most common queries about services, care options, and support. <br />
                        If you need more help, feel free to reach out to our friendly team anytime.
                        </p>
                    {/* <div className="link-btn mb_30"><Link href="/faq" className="btn-1">Ask Questions <span></span></Link></div> */}
                </div>
                <div className="col-lg-6">
                    <ul className="accordion-box alt">                            
<li className="accordion block">
    <div className={isActive.key == 1 ? "acc-btn active" : "acc-btn"} onClick={() => handleToggle(1)}>
        <div className="icon-outer">Q</div>What areas do you service ?
    </div>
    <div className={isActive.key == 1 ? "acc-content current" : "acc-content"}>
        <div className="content">
            <div className="text">
               We proudly deliver services across the <b>Perth Metropolitan area, including Alkimos, Butler, Joondalup, Wanneroo, Rockingham, Baldivis, Mandurah, Midland, Ellenbrook, Kalamunda, Scarborough, Cottesloe, and Fremantle</b>.
            </div>
        </div>
    </div>
</li>

<li className="accordion block">
    <div className={isActive.key == 2 ? "acc-btn active" : "acc-btn"} onClick={() => handleToggle(2)}>
        <div className="icon-outer">Q</div>What types of services do you offer?
    </div>
    <div className={isActive.key == 2 ? "acc-content current" : "acc-content"}>
        <div className="content">
            <div className="text">
                We offer a wide range of services including assisted living, medical and health support, residential care, personal grooming, meal preparation, and 24/7 supervision to ensure safety and comfort.
            </div>
        </div>
    </div>
</li>

<li className="accordion block">
    <div className={isActive.key == 3 ? "acc-btn active" : "acc-btn"} onClick={() => handleToggle(3)}>
        <div className="icon-outer">Q</div>How can I get started with your services?
    </div>
    <div className={isActive.key == 3 ? "acc-content current" : "acc-content"}>
        <div className="content">
            <div className="text">
                Getting started is easy. Just reach out via phone, email, or our website. We'll schedule a free consultation to assess your needs and help you choose the best care options.
            </div>
        </div>
    </div>
</li>

<li className="accordion block">
    <div className={isActive.key == 4 ? "acc-btn active" : "acc-btn"} onClick={() => handleToggle(4)}>
        <div className="icon-outer">Q</div>Are your caregivers trained and certified?
    </div>
    <div className={isActive.key == 4 ? "acc-content current" : "acc-content"}>
        <div className="content">
            <div className="text">
                Yes, all our caregivers are professionally trained, certified, and background-checked. We ensure they meet high standards of compassion, skill, and professionalism to deliver top-quality care.
            </div>
        </div>
    </div>
</li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
        </>
    )
}


